import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const HolidaysMenuIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M2.61448 13.2133C1.34888 11.8872 0.601337 10.1508 0.507812 8.32V7.70667C0.559777 6.87102 0.746637 6.04928 1.06115 5.27333C1.39588 4.34808 1.94671 3.51612 2.66781 2.84667C2.66048 3.23205 2.68053 3.61746 2.72781 4C2.88858 4.89624 3.30803 5.72587 3.93448 6.38667C4.45995 6.85225 5.05063 7.23855 5.68781 7.53333C7.02115 8.2 8.22781 8.86667 9.52781 9.53333C10.3611 9.98 11.2211 10.5267 11.4611 11.4067C11.5635 11.9507 11.5287 12.5117 11.3599 13.039C11.1911 13.5662 10.8937 14.0431 10.4945 14.4267C9.9423 15.0115 9.20989 15.3941 8.41448 15.5133H7.42115C5.59356 15.3632 3.88397 14.5499 2.61448 13.2267V13.2133ZM7.56781 5.68L11.2278 7.58667C11.8363 7.8718 12.3911 8.2597 12.8678 8.73333C13.3132 9.21976 13.6505 9.79508 13.8573 10.4214C14.0642 11.0476 14.1359 11.7106 14.0678 12.3667C14.2779 12.1489 14.4552 11.9019 14.5945 11.6333C15.0923 10.717 15.3921 9.70626 15.4745 8.66667C15.4745 8.63333 15.4745 8.61333 15.4745 8.60667V7.41333C14.9611 3.29333 12.1411 0.82 8.20781 0.5H7.82781C7.11027 0.561629 6.43198 0.853995 5.89448 1.33333C5.58293 1.73727 5.38912 2.21948 5.33448 2.72667C5.19448 4.45333 6.43448 5.08 7.58781 5.68667L7.56781 5.68Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};


